/**
 * How a release's status reads, and what colour it wears.
 *
 * Its own module because four surfaces render it now — the folder tile, the
 * folder header, a version card and the panel's "Latest" chip — and a status
 * that is "Released" green in one place and "released" grey in another reads
 * as two different things.
 */
export const RELEASE_STATUS_COLOR: Record<
  string,
  "success" | "info" | "warning" | "default"
> = {
  released: "success",
  in_progress: "info",
  planned: "warning",
  archived: "default",
};

const RELEASE_STATUS_LABEL: Record<string, string> = {
  released: "Released",
  in_progress: "In progress",
  planned: "Planned",
  archived: "Archived",
};

export function statusLabel(status: string): string {
  return RELEASE_STATUS_LABEL[status] ?? status;
}
